<div class="evolution-charts-view" *ngIf="!loading || effectivePayload">
  <h1 class="evolution-charts-title">{{ 'EVOLUTION_CHARTS.TITLE' | translate }}</h1>

  <section class="evolution-charts-section" *ngIf="patientForDisplay">
    <afoone-patient-data [patient]="patientForDisplay"></afoone-patient-data>
  </section>

  <p-message *ngIf="spMessage" severity="info" [text]="'ACUMULADOS.' + spMessage | translate"></p-message>

  <section class="evolution-charts-charts" *ngIf="effectivePayload?.tests?.length && !spMessage">
    <div class="chart-container" *ngFor="let test of effectivePayload.tests">
      <h3 class="chart-title">{{ test.testName }} ({{ test.unit }})</h3>
      <div class="chart-wrapper" *ngIf="chartReady">
        <canvas #chartCanvas></canvas>
      </div>
    </div>
  </section>

  <p-message *ngIf="error" severity="error" [text]="error"></p-message>
  <p *ngIf="!loading && !error && !spMessage && effectivePayload && (!effectivePayload.tests || !effectivePayload.tests.length)" class="evolution-charts-empty">
    {{ 'EVOLUTION_CHARTS.NO_DATA' | translate }}
  </p>
</div>

<p-progressBar *ngIf="loading && !effectivePayload" mode="indeterminate"></p-progressBar>
